const INVALID_PRODUCT_IDS = ["null", "undefined"];

function normalizeProductId(value) {
  if (value === null || value === undefined) return "";

  const productId = String(value).trim();
  if (!productId || INVALID_PRODUCT_IDS.includes(productId.toLowerCase())) {
    return "";
  }

  return productId;
}

export function resolveProductId(
  value,
  fallback = process.env.VUE_APP_PRODUCT_NAME
) {
  const productId = normalizeProductId(value);
  if (productId) return productId;

  const isMissing =
    value === null || value === undefined || !String(value).trim();
  return isMissing ? normalizeProductId(fallback) : "";
}
